export function calculateBrakeWidth(pixelSize: number, scale: number, insideDialog = false) {
    return (insideDialog ? 1 : 2) * (pixelSize * scale) * scale || 0
}

export function calculateRimWidth(pixelSize: number, scale: number, rimScale = 1, insideDialog = false): number {
    if (!pixelSize || !scale) {
        return 0
    }

    return (insideDialog ? 1 : 2) * (pixelSize * scale) * rimScale * scale
}

export function newCalculationForRimWidth(rimSizePixel: number, scale: number, defaultRimSize: number, selectedSize: number): number {
    if (!rimSizePixel || !scale || !defaultRimSize || !selectedSize) {
        return 0
    }

    return (rimSizePixel * selectedSize * scale) / defaultRimSize
}

export function calculateTopPosition(centerY: number, width: number, scale: number) {
    if (!centerY || !width || !scale) {
        return 0
    }

    const radius = width / 2
    return centerY * scale - radius
}

export function calculateLeftPosition(centerX: number, width: number, scale: number) {
    if (!centerX || !width || !scale) {
        return 0
    }

    const radius = width / 2
    return centerX * scale - radius
}
